"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEASUREMENT_BLOCKHASH = exports.TX_BASE64_ENCODED_SIZE_LIMIT = exports.TX_SIZE_LIMIT = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.TX_SIZE_LIMIT = web3_js_1.PACKET_DATA_SIZE;
exports.TX_BASE64_ENCODED_SIZE_LIMIT = Math.ceil(exports.TX_SIZE_LIMIT / 3) * 4;
exports.MEASUREMENT_BLOCKHASH = {
  blockhash: "65FJ2gp6jC2x87bycfdZpxDyjiodcAoymxR6PMZzfavY",
  lastValidBlockHeight: 160381350
};
//# sourceMappingURL=constants.js.map